'use client';

import Image, { StaticImageData } from 'next/image';

type NextImageProps = {
    src: StaticImageData | string;
    alt: string;
    sizes?: string;
    className?: string;
};

function NextImage({ src, alt, sizes, className }: NextImageProps) {
    return <Image fill priority src={src} alt={alt} style={{ objectFit: 'cover' }} sizes={sizes} className={className} />;
}

export default NextImage;
